import React, { useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import { getQualityCheckProductAndDimensionDetail } from 'src/redux/Actions/VehicleTracking';
import { ReactComponent as Edit } from 'src/Images/icons/common/edit.svg';
import { ReactComponent as Cube } from 'src/Images/icons/common/cube.svg';
import { ReactComponent as Product } from 'src/Images/icons/common/product.svg';
import { useMediaQuery } from '@mui/material';

export default function QualityCheckDetail() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const authReducer = useSelector((state) => state.AuthReducer);
  const tenantOrganisationId = authReducer.userData.organisations?.id;
  const themeColor = authReducer?.userData?.tenant?.theme;
  const isMobile = useMediaQuery('(max-width:767px)');

  const { qualityCheckUniqueNumber } = useParams();

  const vehicleTrackingReducer = useSelector(
    (state) => state.VehicleTrackingReducer,
  );
  const { qualityCheckDetail } = vehicleTrackingReducer;

  useEffect(() => {
    dispatch(
      getQualityCheckProductAndDimensionDetail(
        tenantOrganisationId,
        qualityCheckUniqueNumber,
      ),
    );
  }, [dispatch, tenantOrganisationId, qualityCheckUniqueNumber]);

  return (
    <div className="page-layout div-flex-column">
      <div className="div-flex-column rg-5 horizontal-padding-10 border-bottom">
        <div className="div-flex-row cg-5">
          <span className="text-sm text-grey" href="#">
            Vehicle Tracking
          </span>
          <span className="text-sm text-grey">/</span>
          <span className="text-sm text-semi-bold text-blue">
            <u>Quality Check</u>
          </span>
        </div>
        <div className="div-space-between slider-padding">
          <span className="text-xxl text-bold">Quality Check</span>
        </div>
      </div>
      <div className="div-flex-column rg-20 padding-top-8 horizontal-padding-10 padding-bottom-10">
        <Row className="g-2 div-align-center">
          <Col xxl={4} xl={4} lg={4} md={6} sm={6} xs={6}>
            <span className="text-sm text-semi-bold">Quality Check Name</span>
            <span className="text-red">&nbsp;*</span>
            <input
              className="form-input-section"
              name="qualityCheckName"
              value={qualityCheckDetail.qualityCheckName}
              disabled
            />
          </Col>
          <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
            <span className="text-sm text-semi-bold">Description</span>
            <span className="text-red">&nbsp;*</span>
            <input
              className="form-input-section"
              name="description"
              value={qualityCheckDetail.description}
              disabled
            />
          </Col>
          <Col xxl={2} xl={2} lg={2} md={12} sm={12} xs={12}>
            <div
              className={`padding-top-10 ${isMobile ? 'div-flex-row div-flex-end' : ''}`}
            >
              <div className="div-flex-row div-align-center cg-10 padding-top-10">
                <span className="text-md text-semi-bold">Active</span>
                <label className="toggle" htmlFor="qcToggleTrue">
                  <input
                    id="qcToggleTrue"
                    type="checkbox"
                    aria-label="toggle true"
                    checked={qualityCheckDetail.isActive}
                    disabled
                  />
                  <span className="slider round"></span>
                </label>
              </div>
            </div>
          </Col>
        </Row>
      </div>
      <Row className="g-3 padding-top-10 horizontal-padding-10">
        <Col xxl={5} xl={5} lg={5}>
          <div
            className={`div-flex-column rg-10 ${
              qualityCheckDetail?.products?.length === 0 ? 'border-right' : ''
            }`}
          >
            {qualityCheckDetail?.products?.length === 0 ? (
              <>
                <div className="div-flex-row cg-5 div-align-center">
                  <Product className="icon-size-xxl" />
                  <span className="text-lg text-semi-bold">Products</span>
                </div>
                <div className="quality-check-empty-state-height div-flex-column-center rg-5">
                  <Product className="icon-size-large" />
                  <span className="text-md text-grey">
                    No products attached
                  </span>
                </div>
              </>
            ) : (
              <>
                <div className="div-flex-row cg-5 div-align-center">
                  <Product className="icon-size-xxl" />
                  <span className="text-lg text-semi-bold">Products</span>
                </div>
                <div
                  className={`qc-detal-left-height border-right div-flex-column rg-10 theme-scrollable-container-${themeColor}`}
                >
                  {qualityCheckDetail?.products?.map((dimensionObj, index) => (
                    <div
                      className=" div-flex-row cg-5 w-100"
                      key={dimensionObj.quality_check_id}
                    >
                      <div className="quality-check-list-data div-flex-row div-space-between border border-radius-4 right-margin-10  w-100">
                        <span className="text-sm div-flex-row cg-5">
                          <span className="text-sm ">{index + 1}.</span>
                          {dimensionObj?.product.name}
                        </span>
                        <span className="text-sm">
                          {dimensionObj?.product.description}
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
              </>
            )}
          </div>
        </Col>
        <Col xxl={7} xl={7} lg={7}>
          <div className="div-flex-column rg-10">
            {qualityCheckDetail?.dimensions?.length === 0 ? (
              <>
                <div className="div-flex-row cg-5 div-align-center">
                  <Cube className="icon-size-xxl" />
                  <span className="text-lg  text-semi-bold">Dimensions</span>
                </div>
                <div className="quality-check-empty-state-height div-flex-column-center rg-5">
                  <Cube className="icon-size-large" />
                  <span className="text-md text-grey">
                    No dimensions attached
                  </span>
                </div>
              </>
            ) : (
              <>
                <div className="div-flex-row cg-5 div-align-center">
                  <Cube className="icon-size-xxl" />
                  <span className="text-lg  text-semi-bold">Dimensions</span>
                </div>
                <div className="quality-check-detail-item-table-wrapper">
                  <table className="quality-check-order-item-table">
                    <thead>
                      <tr>
                        <th className="table-head-300">
                          <span className="text-sm text-grey text-semi-bold">
                            Dimension Name
                          </span>
                        </th>
                        <th className="table-head-300">
                          <span className="text-sm text-grey text-semi-bold">
                            Dimension Type
                          </span>
                        </th>
                        <th className="table-head-300">
                          <span className="text-sm text-grey text-semi-bold">
                            Value
                          </span>
                        </th>
                      </tr>
                    </thead>

                    <tbody>
                      {qualityCheckDetail?.dimensions?.map((dim) => (
                        <tr key={dim.quality_check_dimension_id}>
                          <td>
                            <span className="text-sm text-nowrap">
                              {dim?.dimension?.name}
                            </span>
                          </td>
                          <td>
                            <span className="text-sm text-nowrap">
                              {dim?.data_type?.name}
                            </span>
                          </td>
                          <td>
                            <span className="text-sm text-nowrap">
                              {(() => {
                                switch (dim?.data_type?.id) {
                                  case 1: // Numeric Range
                                  case 2: // Numeric Value
                                    return (
                                      <>
                                        {dim?.target_min_value &&
                                          `Min: ${dim.target_min_value} `}
                                        {dim?.target_max_value &&
                                          `Max: ${dim.target_max_value} `}
                                        {dim?.target_value &&
                                          `Value: ${dim.target_value}`}
                                      </>
                                    );

                                  case 3: // String
                                    return dim?.target_value || '--';

                                  case 4: // Choice/Option
                                    return (
                                      dim?.target_option
                                        ?.map((choiceObj) => choiceObj.name)
                                        .join(', ') || '--'
                                    );

                                  case 5: // Boolean
                                    return dim?.target_boolean != null
                                      ? dim.target_boolean
                                        ? 'True'
                                        : 'False'
                                      : '--';

                                  default:
                                    return '--';
                                }
                              })()}
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </>
            )}
          </div>
        </Col>
      </Row>
      <div className="footer-medium-container div-flex-end">
        <button
          aria-label="edit"
          className={`create-icon-btn theme-background-${themeColor}`}
          onClick={() =>
            navigate('/create-quality-check/', {
              state: {
                qualityCheckDetail,
                qualityCheckUniqueNumber,
              },
            })
          }
        >
          <Edit className="icon-size-lg" color="#FFFFFF" />
        </button>
      </div>
    </div>
  );
}
